
/* ===== index.html inline @line 3266 ===== */

  // РЕГИСТРАЦИЯ ПЛАГИНОВ
  gsap.registerPlugin(ScrollTrigger, ScrambleTextPlugin, SplitText);

  // ============================================
  // 1) HOVER SCRAMBLE-TEXT ANIMATION (ПК > 991px)
  // ============================================
  document.fonts.ready.then(() => {
    const parentSelectors = ['.menu-link', '.btn-white', '.menu-open_link', '.btn-black', '.cover-link', '.btn-black--docs'];
    const isDesktop = window.innerWidth > 991;
    const isMotionEnabled = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
    if (!isDesktop || !isMotionEnabled) return;

    document.querySelectorAll('.scramble-hover').forEach(el => {
      const split = new SplitText(el, { type: 'chars, words' });
      const chars = split.chars;
      const original = chars.map(ch => ch.textContent);

      // Параметры анимации (hover)
      const baseDelay     = 0.05;
      const delayStep     = 0.05;
      const duration      = 0.4;
      const scrambleChars = '0123456789';
      const revealDelay   = 0.4;

      function animateHover() {
        gsap.killTweensOf(chars);
        chars.forEach((ch, i) => {
          ch.textContent = original[i];
          gsap.set(ch, { autoAlpha: 0 });
        });
        chars.forEach((ch, i) => {
          if (!original[i].trim()) return;
          gsap.fromTo(ch,
            { autoAlpha: 1 },
            {
              autoAlpha: 1,
              scrambleText: { text: original[i], chars: scrambleChars, revealDelay: revealDelay, tweenLength: false, preserveSpaces: true },
              duration: duration,
              delay: baseDelay + i * delayStep,
              ease: 'sine.in',
              onComplete: () => ch.textContent = original[i]
            }
          );
        });
      }

      parentSelectors.forEach(selector => {
        const parent = el.closest(selector);
        if (parent) parent.addEventListener('mouseenter', animateHover);
      });
    });
  });



/* ===== index.html inline @line 3322 ===== */

  // Регистрируем необходимые плагины
  gsap.registerPlugin(ScrollTrigger, SplitText);

  // Ждём, пока шрифты загрузятся, чтобы не было смещений при разбиении текста
  document.fonts.ready.then(() => {

    // Выбираем все элементы с классом .scramble-title
    document.querySelectorAll('.scramble-title').forEach(el => {
      // 1) Изначально скрываем весь элемент, чтобы он плавно появился при анимации
      gsap.set(el, { opacity: 0 });

      // 2) Разбиваем текст элемента на строки и символы
      const split = SplitText.create(el, {
        type: 'lines, words, chars', // keep word wrappers while animating characters
        wordsClass: 'bv-nowrap-word'
      });

      const lines = split.lines; // массив строк
      const chars = split.chars; // массив символов

      // 3) Для каждой строки явно задаём стили, чтобы сохранить переносы и положение
      lines.forEach(line => {
        gsap.set(line, {
          display: 'block',    // строки будут блочными — сохранят свою высоту
          position: 'relative' // важно для правильного позиционирования анимации
        });
      });

      // 4) Создаём ScrollTrigger, который запускает анимацию при появлении элемента на экране
      ScrollTrigger.create({
        trigger: el,       // сам элемент
        start: 'top 85%',  // когда верх элемента достигает 85% высоты экрана
        once: true,        // анимация срабатывает только один раз

        onEnter: () => {
          // 5) Если элемент имеет класс .first — применяем задержку
          const delay = el.classList.contains('first') ? 4.2 : 0.1;

          // 6) Плавно проявляем весь элемент (контейнер)
          gsap.to(el, {
            delay: delay,      // задержка перед появлением
            duration: 0.3,     // скорость проявления opacity
            opacity: 1,
            ease: 'none'       // без затухания
          });

          // 7) Анимация появления каждого символа
          gsap.from(chars, {
            delay: delay,             // тот же delay, что и у opacity
            duration: 1.8,            // длительность анимации каждого символа
            opacity: 0,               // стартовая прозрачность
            scale: 1,               // начальное уменьшение
            rotation: 0,              // поворот (можно менять вручную)
            filter: 'none',      // размытие в начале
            transformOrigin: '50% 50%', // точка трансформации
            ease: 'power3.out',       // плавное затухание
            stagger: {
              each: 0.03,            // задержка между каждым символом
              from: 'random'          // порядок хаотичный
            }
          });
        }
      });
    });
  });

